export default __webpack_public_path__ + "static/media/details.afd5be06.svg";